export default __webpack_public_path__ + "static/media/download.a019a325.svg";